import { createStyles, makeStyles, Theme } from "@material-ui/core";
import Tooltip from "@material-ui/core/Tooltip";
import { HelpOutline } from "@material-ui/icons";
import { PRIMARY_COLOR, SECONDARY_COLOR } from "../../constants";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    tooltip: { backgroundColor: SECONDARY_COLOR, fontSize: "12px" },
    tooltipArrow: { color: PRIMARY_COLOR },
  })
);

export type helpIconType = {
  title: string;
  marginLeft?: string;
  paddingTop?: string;
  marginBottom?: string;
  color?: string;
};

export function HelpIcon({
  title,
  marginLeft = "0px",
  paddingTop = "0px",
  marginBottom = "0px",
  color = SECONDARY_COLOR,
}: helpIconType) {
  let style = {
    width: "17px",
    height: "17px",
    color: color,
    marginLeft: marginLeft,
    paddingTop: paddingTop,
    marginBottom: marginBottom,
  };
  let classes = useStyles();
  return (
    <div
      style={{
        width: "0px",
      }}
    >
      <Tooltip
        title={<div style={{ fontSize: "14px" }}>{title}</div>}
        arrow
        placement="top"
        classes={{
          tooltip: classes.tooltip,
          arrow: classes.tooltipArrow,
        }}
      >
        <HelpOutline style={style}></HelpOutline>
      </Tooltip>
    </div>
  );
}
